import * as React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { Alert, Button, Classes, Dialog, FormGroup, InputGroup, Switch } from "@blueprintjs/core";
import { toast } from "react-toastify";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { formatCnpj, getMomentFormatter } from "../../utils";
import { BootstrapTable, TableHeaderColumn, SearchField } from "react-bootstrap-table";
import { MDBCol } from "mdbreact";
import { DateInput } from "@blueprintjs/datetime";
import moment from "moment";
import MomentLocaleUtils from "react-day-picker/moment";
import { FgtsDigitalStore } from "../../stores/fgts_digital/FgitsDigitalStore";
import { IAgendamento, newIAgendamento } from "../../model";


@observer
export default class SolicitaFgtsDigital extends React.Component<{}, {}> {

  obs = observable({
    agendamento: newIAgendamento() as IAgendamento,
  })

  constructor(props: any) {
    super(props);
  }

  async componentDidMount() {
  }

  handleClose() {

    FgtsDigitalStore.obs.open_solicitar = false

    this.obs.agendamento.listEmpresas = []
  }

  async handleCreateTask() {


    if (!(this.obs.agendamento.data_solicitacao)) {

      toast.error("Informe um dia válido!", {});
      return

    }

    if (this.obs.agendamento.listEmpresas.length == 0) {

      toast.error("Selecione pelo menos uma Empresa!", {});
      return

    }

    FgtsDigitalStore.obs.open_solicitar = false

    let params = {
      recorrente: this.obs.agendamento.recorrente,
      cnpjs: this.obs.agendamento.listEmpresas,
      descricao: this.obs.agendamento.descricao,
      dia: parseInt(moment(this.obs.agendamento.data_solicitacao).format("DD")),
      mes: parseInt(moment(this.obs.agendamento.data_solicitacao).format("MM")),
      ano: parseInt(moment(this.obs.agendamento.data_solicitacao).format("YYYY"))
    }

    FgtsDigitalStore.obs.loading_solicitacao = true

    await FgtsDigitalStore.handleSolicitaFgtsDigital(params)

    this.obs.agendamento.listEmpresas = []

  }

  handleRowSelect = async (row, checked) => {

    if (checked) {

      this.obs.agendamento.listEmpresas.push(row.cnpj_default);

    } else {

      let index = this.obs.agendamento.listEmpresas.indexOf(row.cnpj_default);

      this.obs.agendamento.listEmpresas.splice(index, 1);

    }

  };

  handleRowSelectAll = async (check, row) => {

    if (check) {

      row?.map(value => {

        this.obs.agendamento.listEmpresas.push(value.cnpj_default);

      });

    } else {

      this.obs.agendamento.listEmpresas = [];
    }

  };

  createCustomSearchField = (props) => {

    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );

  };

  handleDateRealizarChange = (val: Date) => {

    if (val == null) {

      return this.obs.agendamento.data_solicitacao = null

    }

    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (!this.obs.agendamento.recorrente && date1 < dataAgora) {

      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.obs.agendamento.data_solicitacao = null

    } else {

      this.obs.agendamento.data_solicitacao = val

    }

  };

  render() {

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      isSelected: true,
      selected: this.obs.agendamento.listEmpresas,
      bgColor: "rgba(27, 98, 111, 0.1)",
    };

    const options = {
      searchField: this.createCustomSearchField,
    };

    let select_empresas = EmpresaStore.sortedEmpresas.map(map_emp => {

      let emp = EmpresaStore.getByCnpj(map_emp.cnpj);

      if (emp && emp.ativo) {

        return ({
          _id: emp._id,
          razao_social: emp.razao_social,
          apelido: emp.apelido,
          cnpj: formatCnpj(emp.cnpj),
          cnpj_default: emp.cnpj
        })

      }

    });

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    return (
      <>

        <Dialog
          isOpen={FgtsDigitalStore.obs.open_solicitar}
          onClose={() => this.handleClose()}
          className="modal-cnds"
        >
          <h2 className="titleSEFAZ">Solicitar</h2>

          <div style={{ display: "flex" }}>
            <FormGroup label="Recorrência" />
            &nbsp;
            &nbsp;
            <Switch
              innerLabelChecked="Sim"
              innerLabel="Não"
              checked={this.obs.agendamento.recorrente}
              onChange={(e: any) => this.obs.agendamento.recorrente = e.target.checked}
            />
          </div>

          <div style={{ display: "flex" }}>

            <FormGroup className="form-group" label="Descrição" style={{ width: "50%" }}>
              <InputGroup type="text" onChange={(e: any) => this.obs.agendamento.descricao = e.target.value} value={this.obs.agendamento.descricao} />
            </FormGroup>

            &nbsp;

            <FormGroup label={this.obs.agendamento.recorrente ? "Selecione o dia de recorrência *" : "Selecione a data *"} style={{ width: "50%" }}>
              <DateInput
                {...getMomentFormatter(this.obs.agendamento.recorrente ? "DD" : "DD/MM/YYYY")}
                locale="pt-br"
                dayPickerProps={dayPickerProps}
                placeholder={this.obs.agendamento.recorrente ? "DD" : "DD/MM/AAAA"}
                onChange={this.handleDateRealizarChange}
                canClearSelection
                value={this.obs.agendamento.data_solicitacao}
              />
            </FormGroup>

          </div>

          <FormGroup label="Selecione as Empresas *">
            <div className="select-empresa-cnds">
              <BootstrapTable data={select_empresas} selectRow={selectRowProp} options={options} search>
                <TableHeaderColumn dataField="cnpj_default" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="60%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj" width="30%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>
          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleClose()} />
            <Button text="Solicitar" intent="primary" onClick={() => this.handleCreateTask()} />
          </div>
        </Dialog>

      </>
    )
  }
}

